import { createContext, useContext, useState, useEffect } from "react";

const UserTypeContext = createContext();

export const UserTypeProvider = ({ children }) => {
  const storedUserType = localStorage.getItem("selectedUserType");
  
  const [selectedUserType, setSelectedUserType] = useState(
    storedUserType ? storedUserType : ""
  );

  // Save to localStorage whenever updated
  useEffect(() => {
    if (selectedUserType !== null) {
      localStorage.setItem("selectedUserType", selectedUserType);
    }
  }, [selectedUserType]);

  return (
    <UserTypeContext.Provider value={{ selectedUserType, setSelectedUserType }}>
      {children}
    </UserTypeContext.Provider>
  );
};

export const useUserType = () => useContext(UserTypeContext);
